import { mediaMax } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";
import { SettingsV2PageTitle } from "../companySettingsV2.styled";

export const TitleRow = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.md}px;
  justify-content: space-between;
  margin-bottom: ${Spacing.xl}px;

  ${mediaMax.mobile} {
    align-items: flex-start;
    flex-direction: column;
    gap: ${Spacing.md}px;
  }
`;

export const CustomerSettingsTitle = styled(SettingsV2PageTitle)``;

export const ButtonContainer = styled.div`
  flex-shrink: 0;
`;

export const CustomersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CustomerRow = styled.div`
  align-items: center;
  background: ${ColorV2.Blue7};
  border: 1px solid transparent;
  border-radius: ${Radius.xl}px;
  column-gap: 12px;
  display: grid;
  grid-template-columns:
    minmax(220px, 1.4fr) minmax(220px, 1.2fr) minmax(160px, 1fr)
    minmax(236px, auto);
  padding: 12px 16px;
  width: 100%;

  ${mediaMax.desktop} {
    grid-template-columns:
      minmax(200px, 1.4fr) minmax(180px, 1.1fr) minmax(140px, 1fr)
      minmax(224px, auto);
  }

  ${mediaMax.tablet} {
    align-items: flex-start;
    grid-template-columns: 1fr auto;
    row-gap: ${Spacing.sm}px;
  }
`;

export const CustomerCell = styled.div`
  min-width: 0;

  ${mediaMax.tablet} {
    grid-column: 1 / -1;
  }
`;

export const CustomerActionsCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  min-height: 40px;
  min-width: 0;

  ${mediaMax.tablet} {
    grid-column: 1 / -1;
    grid-row: auto;
    justify-content: flex-start;
  }
`;

export const CustomerActionButtons = styled.div`
  align-items: center;
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;
  min-width: 0;
`;

export const ListMessage = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  padding: ${Spacing.md}px 4px;
`;
